import type { ReactNode } from "react";
import { hostKind } from "@/lib/hostKind";
import { NotFoundPage } from "@/features/landing/pages/NotFoundPage";

/**
 * Render `children` only on a CLUB host; otherwise render the not-found page.
 *
 * Club-scoped public surfaces (the Teams index, a team's match list, a public
 * match page) have no club to resolve against on the apex / admin host, so
 * they 404 there — the same shape a stranger URL gets. Pairs with `HostGuard`
 * (which handles the auth/login redirects); this covers the direct app-route
 * URLs a bookmark or stale link might hit on the wrong host.
 */
export function RequireClubHost({ children }: { children: ReactNode }) {
  if (hostKind() !== "club") {
    return <NotFoundPage />;
  }
  return <>{children}</>;
}
